import { useState } from 'react';
import { useNavigate } from 'react-router';

import { ROUTES } from '@/components/Shared/routes/routes';
import { handleError } from '@/services/handleError';
import { dispatch } from '@/store';

import { leasingApi } from '../../../api';
import useLeasingRequestId from '../../hooks/useLeasingRequestId';
import { setActiveTabIndex, setRequestData } from '../store';

const useFetchOrderData = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const { requestId } = useLeasingRequestId();

  const fetchOrderData = async () => {
    if (!requestId) return;

    setIsLoading(true);

    try {
      const [requestResponse, filesResponse] = await Promise.all([
        leasingApi.getLeasingById(requestId),
        leasingApi.getLeasingFiles(requestId)
      ]);

      dispatch(
        setRequestData({ request: requestResponse, files: filesResponse })
      );
      dispatch(
        setActiveTabIndex(requestResponse.status.code !== 'draft' ? 1 : 0)
      );
    } catch (error) {
      handleError(error, {
        customTitle: 'Ошибка при получении данных заявки',
        customDescription: 'Заявка либо не найдена, либо не доступна',
        onError: () => {
          navigate(`${ROUTES.leasings}?tab=legal-entity`);
        }
      });
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchOrderData, isLoading };
};

export default useFetchOrderData;
